import useSWR from "swr";
import { authClient } from "../lib/auth";

export function useOrganizations() {
  const { data, error, isLoading, mutate } = useSWR(
    "organizations",
    async () => {
      const result = await authClient.organization.list();
      return result.data || [];
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 5 * 60 * 1000,
    },
  );

  return {
    organizations: data,
    isLoading,
    error,
    mutate,
  };
}
